import { Info } from 'lucide-react';

const facts = [
  { label: 'Innviet', value: '18. april 1998' },
  { label: 'Arkitekt', value: 'Kjell Kosberg' },
  { label: 'Publikumskapasitet', value: '11,249' },
  { label: 'Underlag', value: 'Kunstgress (siden 2014)' },
];

export default function StadiumFacts() {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center gap-2 mb-4">
        <Info className="w-5 h-5 text-[#2173B9]" />
        <h3 className="text-lg font-semibold">Stadion fakta</h3>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {facts.map((fact) => (
          <div key={fact.label} className="border-l-2 border-[#2173B9] pl-3">
            <div className="text-sm text-gray-600">{fact.label}</div>
            <div className="font-semibold">{fact.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}